import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useSetDefaultEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-set-default-email-options';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { twMerge } from 'tailwind-merge';
import AttachmentsBlock from './components/attachments-block';
import ContactsSettingsBlock from './components/contacts-settings-block';
import EditorBlock from './components/editor-block';
import EmailSettingsBlock from './components/email-settings-block';
import SubstitutesBlock from './components/substitutes-block';
import { DashboardMailEditorProps, ExtendedState } from './types/common';
const DashboardMailEditor = t0 => {
  const $ = _c(58);
  const {
    additionalSubstitutes,
    attachmentsTempState,
    contactsSettings,
    errors,
    inModal,
    disabled,
    isPreFetching,
    isSwitchEditorButtonShown,
    onChangeContactsSettings,
    onChangeEmail,
    setAttachmentsTempState,
    showSettingsLink,
    sidebarItemBlock,
    switchEditorButtonProps,
    tempState,
    withContactsSettings,
    withRecipient,
    mailingId,
    withoutAttachments
  } = t0;
  let t1;
  if ($[0] !== withRecipient) {
    t1 = {
      withRecipient
    };
    $[0] = withRecipient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isOptionsApplied
  } = useSetDefaultEmailOptions(tempState, onChangeEmail, t1);
  let t2;
  if ($[2] !== errors.common) {
    t2 = errors.common && <>{errors.common.map(_temp)}</>;
    $[2] = errors.common;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isPreFetching || !isOptionsApplied;
  let t4;
  if ($[4] !== additionalSubstitutes || $[5] !== disabled || $[6] !== errors || $[7] !== inModal || $[8] !== isSwitchEditorButtonShown || $[9] !== mailingId || $[10] !== onChangeEmail || $[11] !== showSettingsLink || $[12] !== switchEditorButtonProps || $[13] !== t3 || $[14] !== tempState || $[15] !== withRecipient) {
    t4 = <div className="min-w-0 lg:h-auto lg:basis-3/4"><EditorBlock additionalSubstitutes={additionalSubstitutes} isSwitchEditorButtonShown={isSwitchEditorButtonShown} switchEditorButtonProps={switchEditorButtonProps} isPreFetching={t3} disabled={disabled} tempState={tempState} withRecipient={withRecipient} onChangeEmail={onChangeEmail} inModal={inModal} errors={errors} showSettingsLink={showSettingsLink} mailingId={mailingId} /></div>;
    $[4] = additionalSubstitutes;
    $[5] = disabled;
    $[6] = errors;
    $[7] = inModal;
    $[8] = isSwitchEditorButtonShown;
    $[9] = mailingId;
    $[10] = onChangeEmail;
    $[11] = showSettingsLink;
    $[12] = switchEditorButtonProps;
    $[13] = t3;
    $[14] = tempState;
    $[15] = withRecipient;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const t5 = isPreFetching || !isOptionsApplied;
  let t6;
  if ($[17] !== disabled || $[18] !== errors || $[19] !== inModal || $[20] !== onChangeEmail || $[21] !== t5 || $[22] !== tempState) {
    t6 = <EmailSettingsBlock disabled={disabled} isPreFetching={t5} tempState={tempState} onChangeEmail={onChangeEmail} inModal={inModal} errors={errors} />;
    $[17] = disabled;
    $[18] = errors;
    $[19] = inModal;
    $[20] = onChangeEmail;
    $[21] = t5;
    $[22] = tempState;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== attachmentsTempState || $[25] !== disabled || $[26] !== errors.attachments || $[27] !== inModal || $[28] !== isPreFetching || $[29] !== mailingId || $[30] !== setAttachmentsTempState || $[31] !== withoutAttachments) {
    t7 = !withoutAttachments && <AttachmentsBlock disabled={disabled} isPreFetching={isPreFetching} attachmentsTempState={attachmentsTempState} setAttachmentsTempState={setAttachmentsTempState} inModal={inModal} mailingId={mailingId} errors={errors?.attachments} />;
    $[24] = attachmentsTempState;
    $[25] = disabled;
    $[26] = errors.attachments;
    $[27] = inModal;
    $[28] = isPreFetching;
    $[29] = mailingId;
    $[30] = setAttachmentsTempState;
    $[31] = withoutAttachments;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== inModal || $[34] !== sidebarItemBlock) {
    t8 = sidebarItemBlock && <DisclosureBox wrapperClassName={twMerge(inModal && "border border-text-secondary/30 rounded-lg", sidebarItemBlock.showErrorOutline && "border-danger")} title={<b className="text-text-primary text-start text-[17px]">{sidebarItemBlock.title}</b>}>{sidebarItemBlock.Component}</DisclosureBox>;
    $[33] = inModal;
    $[34] = sidebarItemBlock;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== contactsSettings || $[37] !== disabled || $[38] !== inModal || $[39] !== isPreFetching || $[40] !== onChangeContactsSettings || $[41] !== withContactsSettings) {
    t9 = withContactsSettings && <ContactsSettingsBlock disabled={disabled} isPreFetching={isPreFetching} contactsSettings={contactsSettings} onChangeContactsSettings={onChangeContactsSettings} inModal={inModal} />;
    $[36] = contactsSettings;
    $[37] = disabled;
    $[38] = inModal;
    $[39] = isPreFetching;
    $[40] = onChangeContactsSettings;
    $[41] = withContactsSettings;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] !== additionalSubstitutes || $[44] !== inModal) {
    t10 = <SubstitutesBlock inModal={inModal} additionalSubstitutes={additionalSubstitutes} />;
    $[43] = additionalSubstitutes;
    $[44] = inModal;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  let t11;
  if ($[46] !== t10 || $[47] !== t6 || $[48] !== t7 || $[49] !== t8 || $[50] !== t9) {
    t11 = <div className="static top-5 flex h-fit flex-col gap-5 sm:min-w-[320px] lg:sticky lg:basis-1/4">{t6}{t7}{t8}{t9}{t10}</div>;
    $[46] = t10;
    $[47] = t6;
    $[48] = t7;
    $[49] = t8;
    $[50] = t9;
    $[51] = t11;
  } else {
    t11 = $[51];
  }
  let t12;
  if ($[52] !== t11 || $[53] !== t4) {
    t12 = <div className="flex flex-col gap-5 lg:flex-row">{t4}{t11}</div>;
    $[52] = t11;
    $[53] = t4;
    $[54] = t12;
  } else {
    t12 = $[54];
  }
  let t13;
  if ($[55] !== t12 || $[56] !== t2) {
    t13 = <div className="flex flex-col gap-3">{t2}{t12}</div>;
    $[55] = t12;
    $[56] = t2;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  return t13;
};
export default DashboardMailEditor;
function _temp(error, index) {
  return <p className="text-danger px-6 text-center text-sm" key={index}>{error}</p>;
}